import { render, staticRenderFns } from "./CartPanel.vue?vue&type=template&id=4120ef88&scoped=true"
import script from "./CartPanel.vue?vue&type=script&lang=js"
export * from "./CartPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120ef88",
  null
  
)

export default component.exports